module.exports = __webpack_public_path__ + "2a5dd27da64861bf0c0723af372ac412.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/pages/guide_tours_page.jpg
// module id = 872
// module chunks = 0